// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_l8-6";
export var emphasizeQuantity = "_l8-3";
export var flatBottomCorners = "_l8-5";
export var productImage = "_l8-0";
export var quantityContainer = "_l8-2";
export var tooltip = "_l8-1";
export var wrapAndEllipsesOverflow = "_l8-4";